import React from 'react';
import { StyleSheet, View } from 'react-native';
import type { BottomTabBarProps } from '@react-navigation/bottom-tabs';
import { useSafeAreaInsets } from 'react-native-safe-area-context';

import { layout } from '../../core/theme/layout';
import { spacing } from '../../core/theme/tokens';
import { GlassTabBarItems } from './glassTabBar/GlassTabBarItems';
import { TabBarGlassBackground } from './glassTabBar/TabBarGlassBackground';

export function GlassTabBar(props: BottomTabBarProps) {
  const insets = useSafeAreaInsets();

  return (
    <View
      style={[styles.wrapper, { paddingBottom: Math.max(insets.bottom, spacing.sm) }]}
      pointerEvents="box-none"
    >
      <View style={styles.inner}>
        <TabBarGlassBackground style={styles.bar}>
          <GlassTabBarItems {...props} isWeb />
        </TabBarGlassBackground>
      </View>
    </View>
  );
}

const styles = StyleSheet.create({
  wrapper: {
    position: 'absolute',
    left: 0,
    right: 0,
    bottom: 0,
    alignItems: 'center',
    paddingHorizontal: spacing.md,
    paddingTop: spacing.sm,
  },
  inner: {
    width: '100%',
    maxWidth: layout.webAppMaxWidth - layout.webGutter * 2,
  },
  bar: {
    width: '100%',
  },
});
